import { Chip as d, chipClasses as l } from "@mui/material";
import { styled as $, css as r } from "./styled2.mjs";
const s = (o) => r`
	.${l.icon} {
		color: ${o};
		opacity: 0.6;

		&:hover {
			color: ${o};
			opacity: 1;
		}
	}

	.${l.deleteIcon} {
		color: ${o};
		opacity: 0.7;

		&:hover {
			color: ${o};
			opacity: 1;
		}
	}
`, b = (o, t) => r`
	color: ${o};
	background-color: ${t};

	${s(o)}
`, y = (o, t, a) => r`
	color: ${o};
	background-color: ${t};
	border: 1px solid ${a};

	${s(o)}
`, u = (o, t) => r`
	color: ${o};
	background-color: ${t};
	border: unset;

	${s(o)}
`, k = (o) => r`
	box-shadow: ${o.tokens.shadow.small} !important;
`, x = (o, t, a, c) => {
  let i = r``, e = o.palette[a].main, n = o.palette.background.level3;
  const p = o.palette[a].main30;
  switch (t) {
    case "outlined":
      i = y(e, n, p);
      break;
    case "secondary":
      n = o.palette[a].main08, i = u(e, n);
      break;
    case "primary":
    default:
      e = o.palette[a].contrast, n = o.palette[a].main, i = b(e, n);
      break;
  }
  return c && (i = r`
			${i}
			${k(o)}
		`), i;
}, m = $(d)`
	${({ theme: o, $variant: t, $color: a, $hasShadow: c }) => x(o, t, a, c)}
`;
export {
  m as StyledChip
};
//# sourceMappingURL=styles61.mjs.map
